import React from 'react';
import '../styles/ShowRoomCondo.css'; 
import bed1 from '../assets/sample bedroom1.JPG'
import bed2 from '../assets/sample bedroom2.JPG'
import bed3 from '../assets/sample bedroom3.JPG'

function ShowroomCondo() {
  // Sample data for condominiums
  const condominiums = [
    {
      id: 1,
      name: 'The Luxe Residences',
      address: '123 Orchard Road, Singapore 238867',
      rooms: 3,
      sqft: 1200,
      image: bed1,
    },
    {
      id: 2,
      name: 'Skyline Towers',
      address: '456 Marina Bay, Singapore 018956',
      rooms: 4,
      sqft: 1500,
      image: bed2
    },
    {
      id: 3,
      name: 'Green Valley Condo',
      address: '789 Bukit Timah Road, Singapore 269897',
      rooms: 2,
      sqft: 900,
      image: bed3
    },
  ];

  return (
    <div className='showroomCondo'>
      <h1>Condominium Showroom</h1>
      <p>Explore our exclusive selection of condominiums.</p>
      <div className='propertyList'>
        {condominiums.map((condo) => (
          <div key={condo.id} className='propertyView'>
            <h2>{condo.name}</h2>
            <img src={condo.image} alt={condo.name} className='propertyViewImage' />
            <div className='propertyViewDetails'>
              <p><strong>Address:</strong> {condo.address}</p>
              <p><strong>Rooms:</strong> {condo.rooms}</p>
              <p><strong>Square Feet:</strong> {condo.sqft} sqft</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ShowroomCondo;